import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Modal, Input, Form, Radio } from 'antd';

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 10 }
};

const ModalView = ({ visible, feedbackForm: initialFeedbackForm, onOk, onCancel, language }) => {
  const [feedbackForm, setFeedbackForm] = useState(initialFeedbackForm);

  useEffect(() => {
    setFeedbackForm(initialFeedbackForm);
  }, [initialFeedbackForm]);

  return (
    <div>
      <Modal
        open={visible}
        width={800}
        height={800}
        title={language !== 'English' ? '予測フィードバック' : 'Prediction Feedback'}
        okText="Submit"
        onOk={() => onOk(feedbackForm)}
        onCancel={onCancel}
      >
        <Form {...formItemLayout}>
          <Form.Item
            label={language !== 'English' ? '時間' : 'TimeStamp'}
          >
            <Input
              readOnly
              value={moment
                .utc(feedbackForm.Timestamp, 'YYYY-MM-DD HH:mm:ss')
                .local()
                .format('YYYY-MM-DD HH:mm')}
            />
          </Form.Item>
          {feedbackForm.NotificationId && (
            <Form.Item
              label={language !== 'English' ? '通知ID' : 'Notification Id'}
            >
              <Input readOnly value={feedbackForm.NotificationId} />
            </Form.Item>
          )}
          <Form.Item
            label={language !== 'English' ? 'タグ名' : 'Tag Name'}
          >
            <Input readOnly value={feedbackForm.TagName} />
          </Form.Item>
          <Form.Item
            label={language !== 'English' ? '予測タイプ' : 'Prediction Type'}
          >
            <Input readOnly value={feedbackForm.PredictionType} />
          </Form.Item>
          {feedbackForm.NotificationId && (
            <Form.Item
              label={language !== 'English' ? '通知' : 'Notification'}
            >
              <Input readOnly value={feedbackForm.TagDescription} />
            </Form.Item>
          )}
          <Form.Item
            label={language !== 'English' ? 'アクション' : 'Action'}
          >
            <Radio.Group
              value={feedbackForm.Action}
              onChange={(e) =>
                setFeedbackForm({
                  ...feedbackForm,
                  Action: e.target.value
                })
              }
            >
              <Radio value="yes">
                {language !== 'English' ? 'はい' : 'Yes'}
              </Radio>
              <Radio value="no">
                {language !== 'English' ? 'いいえ' : 'No'}
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={language !== 'English' ? 'コメント' : 'Comment'}
          >
            <Input.TextArea
              value={feedbackForm.Comment}
              onChange={(e) =>
                setFeedbackForm({
                  ...feedbackForm,
                  Comment: e.target.value
                })
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(ModalView);